import React, { useContext } from 'react';
import { Nav } from '@gjensidige/core-navigation';

import { configCommercial, SubMenuCTA, SubMenuItem, useConfigPrivate } from '../config';
import { hideItem, IS_BEDRIFT } from '../utils/utils';

const SubMenuContent = ({
  subMenuCTAs,
  subMenuItems
}: {
  subMenuCTAs?: SubMenuCTA[];
  subMenuItems?: SubMenuItem[];
}) => {
  const isMobile = useContext(Nav.isMobile);
  return (
    <>
      {subMenuItems?.map((submenuItem, index) => {
        const { hideCondition, mobileOnly, desktopOnly, ...rest } = submenuItem;
        return (
          !hideCondition &&
          !hideItem(isMobile, mobileOnly, desktopOnly) && (
            <>
              <Nav.Item key={index} {...rest} />
            </>
          )
        );
      })}
      {subMenuCTAs?.map((cta, index) => {
        const { hideCondition, mobileOnly, desktopOnly, ...rest } = cta;
        return (
          !hideCondition &&
          !hideItem(isMobile, mobileOnly, desktopOnly) && (
            <>
              <Nav.CTA key={index} {...rest} />
            </>
          )
        );
      })}
    </>
  );
};

export const NavContent = () => {
  const { menuItems } = IS_BEDRIFT ? configCommercial() : useConfigPrivate();
  const isMobile = useContext(Nav.isMobile);
  return (
    <>
      {menuItems.map((item, index) => {
        const { hideCondition, subMenuItems, subMenuCTAs, mobileOnly, desktopOnly, icon, ...rest } = item;
        const hasSubmenu = subMenuItems || subMenuCTAs;
        return (
          !hideCondition &&
          !hideItem(isMobile, mobileOnly, desktopOnly) && (
            <Nav.Item key={index} icon={icon} {...rest}>
              {hasSubmenu && <SubMenuContent subMenuItems={subMenuItems} subMenuCTAs={subMenuCTAs} />}
            </Nav.Item>
          )
        );
      })}
    </>
  );
};
